import { Typography } from "@mui/material";
import React from "react";

/** `signed`: the request is complete, so there is nothing left to send. */
const AIDisclaimer = ({ signed = false }: { signed?: boolean }) => (
  <Typography
    sx={{
      display: "block",
      textAlign: "center",
      fontSize: "0.6rem",
      lineHeight: 1.45,
      color: "text.secondary",
      px: 1,
      pt: 1,
      // No opacity: at 0.8 the text fell to 3.79:1 (WCAG 1.4.3).
    }}
  >
    {signed
      ? "AI can make mistakes. Verify important details against the signed document before relying on them."
      : "AI can make mistakes. Verify important details against the document before sending."}
  </Typography>
);

export default AIDisclaimer;
